<template>
	<div>
		<b-card title="Card Title" no-body>
			<b-card-header header-tag="nav">
				<b-nav card-header tabs>
					<b-nav-item to="/sentiment/cyclicality" exact exact-active-class="active">情绪周期</b-nav-item>
					<b-nav-item to="/sentiment/hot" exact exact-active-class="active">情绪日内</b-nav-item>
					<b-nav-item to="/sentiment/cyclicality/vip" exact exact-active-class="active">情绪周期VIP</b-nav-item>
					<b-nav-item to="/sentiment/cyclicality/year" exact exact-active-class="active">情绪周期-年</b-nav-item>
					<b-nav-item to="/sentiment/space" exact exact-active-class="active">空间板</b-nav-item>
					<b-nav-item to="/sentiment/popular" exact exact-active-class="active">人气</b-nav-item>
					<b-nav-item to="/sentiment/popular2" exact exact-active-class="active">人气2</b-nav-item>
					<b-nav-item to="/sentiment/popular/compare" exact exact-active-class="active">人气对比</b-nav-item>
					<b-nav-item to="/tdx/hot2" exact exact-active-class="active">情绪热度单页</b-nav-item>

				</b-nav>
			</b-card-header>

			<b-card-body>
				<router-view></router-view>
			</b-card-body>
		</b-card>
	</div>
</template>

<script>
	// import Popular from '../../components/sentiment/Popular.vue'
	// import SentimentPopular from './SentimentPopular.vue'

	export default {
		name: 'Sentiment',
		components: {
			// SentimentPopular,
			// Navbar
		}
	}
</script>

<style scoped>
.card-header {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
}

.nav-tabs {
    flex-wrap: nowrap !important;
    white-space: nowrap;
}

.nav-link {
    padding: 0.5rem 0.75rem;
}

@media (max-width: 768px) {
    .nav-link {
        padding: 0.4rem 0.5rem;
        font-size: 0.9rem;
    }
}
</style>
